module.exports = __webpack_public_path__ + "img/hest0.32cc9907.jpg";